const styles = () => ({
  checkIcon: { color: 'green' },
  cancelIcon: { color: 'red' }
});

export default styles;
